<mat-card appearance="outlined" class="col-12">
  <mat-card-content>
    <company-events-toolbar (onClickAction)="toolbarAction($event)"
      (onEditToggle)="changeEditStatus($event)"
      [userOnCalendar]="isOnUserCalendar"
      [userCanCreate]="permissions._create"
    [userCanEdit]="permissions._edit"></company-events-toolbar>
    @if (!isEditMode) {
      <div>
        <div class="row">
          <h2 class="event-name">{{ editEventForm.controls['name'].value }}</h2>
        </div>
        <div>
          <h4 class="event-type">{{ editEventForm.controls['typeName'].value }}</h4>
        </div>
        @if (editEventForm.controls['is_cancelled'].value) {
          <div class="col info cancelled">
            <mat-icon>warning</mat-icon>
            <div class="col info-list txt-red">Cancelled</div>
          </div>
        }
        @if (editEventForm.controls['is_postponed'].value) {
          <div class="col info postponed">
            <mat-icon>warning</mat-icon>
            <div class="col info-list">Postponed</div>
          </div>
        }
        @if (editEventForm.controls['is_sponsored'].value) {
          <div class="col info sponsored">
            <mat-icon>diamond</mat-icon>
            <div class="col info-list">CREA Sponsored</div>
          </div>
        }
        @if (editEventForm.controls['is_sponsored'].value && editEventForm.controls['sponsorshipAmount'].value!=null) {
          <div class="col info sponsored-amount">
            <mat-icon>attach_money</mat-icon>
            <div class="col info-list">Sponsorship Amount: </div>
            <div class="col">{{ editEventForm.controls['sponsorshipAmount'].value | currency: "USD" : "symbol": "1.0-0"}}</div>
          </div>
        }
        @if (editEventForm.controls['is_cosponsored'].value) {
          <div class="col info cosponsor">
            <mat-icon>groups</mat-icon>
            <div class="col info-list"> {{ editEventForm.controls['cosponsor'].value!==null ? "Cosponsor: " : "Cosponsored" }}</div>
            @if (editEventForm.controls['cosponsor'].value!==null) {
              <div class="col">{{ editEventForm.controls['cosponsor'].value }}</div>
            }
          </div>
        }
        @if (!editEventForm.controls['is_cancelled'].value) {
          <div class="row">
            <div class="col info dates">
              <mat-icon>calendar_month</mat-icon>
              <div class="col info-list">Dates: </div>
              @if (activeEventDate==null && inactiveEventDate!==null) {
                <div class="col info-list">TBD</div>
              }
              @if (activeEventDate!==null && (startDate!==null && endDate==null)) {
                <div class="col">{{ startDate | date }}</div>
              }
              @if (activeEventDate!==null && (startDate!==null && endDate!==null)) {
                <div class="col">{{ startDate | date }} - {{ endDate | date }}</div>
              }
            </div>
          </div>
        }
        @if (editEventForm.controls['is_postponed'].value) {
          <div class="row">
            <div class="col previous">
              <mat-icon>event_busy</mat-icon>
              @if (inactiveEventDate!==null && (inactiveEventDate.start_date!==null && inactiveEventDate.end_date==null)) {
                <div class="col">Previous Dates: {{inactiveEventDate.start_date | date }}</div>
              }
              @if (inactiveEventDate!==null && (inactiveEventDate.start_date!==null && inactiveEventDate.end_date!==null)) {
                <div class="col">Previous Dates: {{inactiveEventDate.start_date | date }} - {{inactiveEventDate.end_date | date }}</div>
              }
            </div>
          </div>
        }
        @if (editEventForm.controls['is_cancelled'].value) {
          <div class="row">
            <div class="col previous">
              <mat-icon>event_busy</mat-icon>
              @if (activeEventDate!==null && (activeEventDate.start_date!==null && activeEventDate.end_date==null)) {
                <div class="col">Previous Dates: {{activeEventDate.start_date | date }}</div>
              }
              @if (activeEventDate!==null && (activeEventDate.start_date!==null && activeEventDate.end_date!==null)) {
                <div class="col">Previous Dates: {{activeEventDate.start_date | date }} - {{activeEventDate.end_date | date }}</div>
              }
            </div>
          </div>
        }
        @if (startTime && !editEventForm.controls['is_cancelled'].value) {
          <div class="row">
            <div class="col info dates">
              <mat-icon>schedule</mat-icon>
              <div class="col info-list">Time: </div>
              @if (activeEventDate==null && inactiveEventDate!==null) {
                <div class="col info-list">TBD</div>
              }
              @if (activeEventDate!==null && (startTime!==null && endTime==null)) {
                <div class="col">{{ startDate + " " + startTime | date: 'shortTime' }} {{this.timezone ? this.timezone.abbr : ""}}</div>
              }
              @if (activeEventDate!==null && (startTime!==null && endTime!==null)) {
                <div class="col">{{ startDate + " " + startTime | date: 'shortTime' }} - {{ startDate + " " + endTime | date: 'shortTime' }} {{ this.timezone ? this.timezone.abbr : ""}}</div>
              }
            </div>
          </div>
        }
        @if ((event.is_postponed || editEventForm.controls['is_postponed'].value) && (inactiveEventDate!==null && inactiveEventDate.start_time!==null)) {
          <div class="row">
            <div class="col previous">
              <mat-icon>schedule</mat-icon>
              <div class="col">Previous Times: {{ this.dateTimeService.formatCompanyEventTimes(inactiveEventDate).startDate + " " + this.dateTimeService.formatCompanyEventTimes(inactiveEventDate).viewStart | date: 'shortTime' }} - {{ this.dateTimeService.formatCompanyEventTimes(inactiveEventDate).startDate + " " + this.dateTimeService.formatCompanyEventTimes(inactiveEventDate).viewEnd | date: 'shortTime' }} {{this.timezone ? this.timezone.abbr : ""}}</div>
            </div>
          </div>
        }
        @if ((event.is_cancelled || editEventForm.controls['is_cancelled'].value) && (activeEventDate!==null && activeEventDate.start_time!==null)) {
          <div class="row">
            <div class="col previous">
              <mat-icon>schedule</mat-icon>
              <div class="col">Previous Times: {{ this.dateTimeService.formatCompanyEventTimes(activeEventDate).startDate + " " + this.dateTimeService.formatCompanyEventTimes(activeEventDate).viewStart | date: 'shortTime' }} - {{ this.dateTimeService.formatCompanyEventTimes(activeEventDate).startDate + " " + this.dateTimeService.formatCompanyEventTimes(activeEventDate).viewEnd | date: 'shortTime' }} {{this.timezone ? this.timezone.abbr : ""}}</div>
            </div>
          </div>
        }
        @if (addresses.length > 0) {
          <div class="row">
            @for (eventAddress of addresses; track eventAddress) {
              <div class="col info address">
                @if (addresses.indexOf(eventAddress)==0) {
                  <mat-icon>location_on</mat-icon>
                }
                @if (addresses.indexOf(eventAddress)!==0) {
                  <mat-icon></mat-icon>
                }
                @if (eventAddress.name!==null) {
                  <div class="info-list">{{ eventAddress.name }}:</div>
                }
                <div>{{ eventAddress.address.address1 + "," }} {{ eventAddress.address.address2 ? eventAddress.address.address2 + "," : ""}}
                  {{ eventAddress.address.zipCode.city + ", " }} {{ eventAddress.address.zipCode.state.abbreviation }} {{ eventAddress.address.zipCode.zipcode}}
                </div>
              </div>
            }
          </div>
        }
        @if (isOnUserCalendar) {
          <div class="row">
            <div class="col info on-outlook-calendar">
              <mat-icon>mail_outline</mat-icon>
              <div class="col info-list">This event is on your Outlook Calendar</div>
            </div>
          </div>
        }
      </div>
    }
    @if (isEditMode) {
      <div>
        <div class="row align-top edit-row">
          <div class="col-5">
            <h3><mat-icon class="edit-icon">info</mat-icon>General Information</h3>
            <form [formGroup]="editEventForm">
              <div class="row align-top">
                <mat-form-field>
                  <mat-label>Event Name</mat-label>
                  <input matInput formControlName="name" name="name" type="text"/>
                </mat-form-field>
              </div>
              <div class="row align-top">
                <mat-form-field>
                  <mat-label>Event Type</mat-label>
                  <mat-select formControlName="type" (selectionChange)="onEventTypeSelectionChange($event)">
                    @for (eventType of selectEventTypes; track eventType) {
                      <mat-option [disabled]="selectEventTypes.length==0" [value]="eventType.id" >{{eventType.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="row align-top sponsor-row">
                <div class="col-6 sponsor-title">
                  <mat-label>CREA Sponsorship</mat-label>
                </div>
                <div class="col-6 sponsor-title">
                  <mat-radio-group formControlName="is_sponsored">
                    <mat-radio-button [checked]="editEventForm.controls['is_sponsored'].value==true" [value]=true (change)="radioChange($event, 'sponsorship')">Yes</mat-radio-button>
                    <mat-radio-button [checked]="editEventForm.controls['is_sponsored'].value==false" [value]=false (change)="radioChange($event, 'sponsorship')">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
              @if (editEventForm.controls['is_sponsored'].value==true) {
                <div class="row align-top">
                  <mat-form-field>
                    <mat-label>Sponsorship Amount</mat-label>
                    <input matInput formControlName="sponsorshipAmount" name="sponsorshipAmount" type="number"/>
                  </mat-form-field>
                </div>
              }
              <div class="row align-top sponsor-row">
                <div class="col-6 sponsor-title">
                  <mat-label>Co-sponsorship</mat-label>
                </div>
                <div class="col-6 sponsor-title">
                  <mat-radio-group formControlName="is_cosponsored">
                    <mat-radio-button [checked]="editEventForm.controls['is_cosponsored'].value==true" [value]=true (change)="radioChange($event, 'cosponsor')">Yes</mat-radio-button>
                    <mat-radio-button [checked]="editEventForm.controls['is_cosponsored'].value==false" [value]=false (change)="radioChange($event, 'cosponsor')">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
              @if (editEventForm.controls['is_cosponsored'].value==true) {
                <div class="row align-top">
                  <mat-form-field>
                    <mat-label>Cosponsor Name</mat-label>
                    <input matInput formControlName="cosponsor" name="cosponsor" type="text"/>
                  </mat-form-field>
                </div>
              }
            </form>
          </div>
          <div class="col-5">
            <h3><mat-icon>events</mat-icon>Date/Time</h3>
            <form [formGroup]="editEventForm">
              <div class="row align-top action-btn">
                <div class="col-md-3">
                  <button mat-button (click)="togglePostpone($event)" [ngClass]="editEventForm.controls['is_postponed'].value==true ? 'postpone-btn-active' : 'postpone-btn-inactive'">Postponed</button>
                </div>
                <div class="col-md-3">
                  <button mat-button (click)="toggleCancelled($event)" [ngClass]="editEventForm.controls['is_cancelled'].value==true ? 'cancelled-btn-active' : 'cancelled-btn-inactive'">Cancelled</button>
                </div>
              </div>
              @if (editEventForm.controls['is_postponed'].value==true || editEventForm.controls['is_cancelled'].value==true) {
                <div>
                  <span class="cancel-warning"><mat-icon>warning</mat-icon>Cancelling or Postponing the event indefinitely will cancel the event on Outlook. Any updates to this event will not be reflected on the Outlook event.</span>
                </div>
              }
              @if (editEventForm.controls['is_postponed'].value==true) {
                <div class="row align-top">
                  <h4>Rescheduled Dates and Times</h4>
                  <div class="row align-top">
                    <mat-form-field>
                      <mat-label>Start Date</mat-label>
                      <input matInput [matDatepicker]="postponeStartPicker" formControlName="postponeStartDate" name="postponeStartDate">
                      <mat-datepicker-toggle matIconPrefix [for]="postponeStartPicker"></mat-datepicker-toggle>
                      <mat-datepicker #postponeStartPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="row align-top">
                    <mat-form-field>
                      <mat-label>End Date</mat-label>
                      <input matInput [matDatepicker]="postponeEndPicker" formControlName="postponeEndDate" name="postponeEndDate"/>
                      <mat-datepicker-toggle matIconPrefix [for]="postponeEndPicker"></mat-datepicker-toggle>
                      <mat-datepicker #postponeEndPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="row">
                    <mat-label>Start Time</mat-label>
                    <input class="time-input" type="time" formControlName="postponeStartTime" name="postponeStartTime">
                  </div>
                  <div class="row ">
                    <mat-label>End Time</mat-label>
                    <input class="time-input" type="time" formControlName="postponeEndTime" name="postponeEndTime">
                  </div>
                  <div class="row">
                    <mat-form-field>
                      <mat-label>Timezone</mat-label>
                      <mat-select formControlName="postponeTimezone">
                        @for (tzone of timezones; track tzone) {
                          <mat-option [value]="tzone.tz">{{tzone.abbr}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              }
              @if (editEventForm.controls['is_postponed'].value==true) {
                <div class="row align-top">
                  <h4>Original Dates and Times</h4>
                </div>
              }
              <div class="row align-top">
                <mat-form-field>
                  <mat-label>Start Date</mat-label>
                  <input matInput [matDatepicker]="startPicker" formControlName="startDate" name="startDate">
                  <mat-datepicker-toggle matIconPrefix [for]="startPicker"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="row align-top">
                <mat-form-field>
                  <mat-label>End Date</mat-label>
                  <input matInput [matDatepicker]="endPicker" formControlName="endDate" name="endDate"/>
                  <mat-datepicker-toggle matIconPrefix [for]="endPicker"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-label>Start Time</mat-label>
                <input class="time-input" type="time" formControlName="startTime" name="startTime">
              </div>
              <div class="row ">
                <mat-label>End Time</mat-label>
                <input class="time-input" type="time" formControlName="endTime" name="endTime">
              </div>
              <div class="row">
                <mat-form-field>
                  <mat-label>Timezone</mat-label>
                  <mat-select formControlName="timezone">
                    @for (tzone of timezones; track tzone) {
                      <mat-option [value]="tzone.tz">{{tzone.abbr}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </form>
          </div>
          <mat-divider></mat-divider>
          <div class="row align-top">
            <div class="col">
              <div class="add-address">
                <h3><mat-icon>home</mat-icon>Addresses</h3>
                <button (click)="openAddressScreen()" class="open-address-btn">
                  @if (!addressToggle) {
                    <mat-icon>expand_more</mat-icon>
                  }
                  @if (addressToggle) {
                    <mat-icon>expand_less</mat-icon>
                  }
                </button>
              </div>
            </div>
          </div>
          @if (addressToggle) {
            <div class="row align-top">
              @if (addresses.length>0) {
                <div>
                  @for (address of addresses; track address) {
                    <div class="row align-top centered">
                      <div class="col-6 address-row">
                        <div class="row">
                          <div class="col-11">
                            @if (address.name!=null) {
                              <div class="addr-label centered">{{address.name}}:</div>
                            }
                            <div class="address-line">
                              {{address.address.address1}} {{address.address.address2 ? address.address.address2 : ", "}}
                              {{address.address.zipCode.city + ", "}} {{address.address.zipCode.state.abbreviation}} {{address.address.zipCode.zipcode}}
                            </div>
                          </div>
                          <div class="col-1 addr-btns"><button class="delete-addr-btn" matTooltip="Remove address" (click)="deleteAddressFromEvent(address)"><mat-icon>delete</mat-icon></button>
                          <button class="delete-addr-btn" matTooltip="Edit address" (click)="toggleAddressChange(address)"><mat-icon>edit</mat-icon></button></div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <div class="row align-top centered">
                <div class="col-6">
                  <form [formGroup] = "addressForm">
                    <div class="row align-top">
                      <mat-form-field>
                        <mat-label>Label (Optional)</mat-label>
                        <input matInput formControlName="name" name="name" type="text" />
                      </mat-form-field>
                    </div>
                    <div class="row align-top">
                      <mat-form-field>
                        <mat-label>Address</mat-label>
                        <input matInput formControlName="address1" name="address1" type="text" />
                      </mat-form-field>
                    </div>
                    <div class="row align-top">
                      <mat-form-field>
                        <mat-label>Apt, Suite, etc...</mat-label>
                        <input matInput formControlName="address2" name="address2" type="text" />
                      </mat-form-field>
                    </div>
                    <div class="row align-top">
                      <mat-form-field>
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city" name="city" type="text" />
                      </mat-form-field>
                    </div>
                    <div class="row align-top">
                      <mat-form-field>
                        <mat-label>State</mat-label>
                        <mat-select formControlName="state">
                          @for (state of selectStates; track state) {
                            <mat-option [disabled]="selectStates.length==0" [value]="state">{{state.name}}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="row align-top">
                      <mat-form-field>
                        <mat-label>Zipcode</mat-label>
                        <input matInput formControlName="zipCode" name="zipCode" maxLength=5/>
                        @if (addressForm.controls['zipCode'].hasError('pattern') ||
                          addressForm.controls['zipCode'].hasError('min')
                          ) {
                          <mat-error
                          >Zipcode must be 5 digits</mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="row align-top centered">
                      <button class="add-address-btn" mat-button [matTooltip]="isEditingAddress ? 'Update Address' : 'Add Address'" (click)="saveAddress()"><mat-icon>save</mat-icon>{{isEditingAddress ? "Update Address" : "Add Address" }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
